import { net } from 'zf-web-infra';
import { t } from 'zf-web-components';
import type { Menu, MenuIconMap, MenuItems, MenuResponse, Menus } from './types';

export class MenuService {

  private menus?: Menus;

  /**
   * 获取指定应用的菜单
   */
  async fetchMenu(app: string, iconMap: MenuIconMap): Promise<MenuItems> {
    if (this.menus == null) {
      const menus = await net.get<MenuResponse>({
        url: '/api/menu/list',
        params: { condition: { kind: app } }
      });

      // TODO: 这个 key 要跟微应用的 key 一致
      this.menus = {
        system: this.format('system', menus.system, iconMap),
        admin: this.format('admin', menus.admin, iconMap),
        analyze: this.format('analyze', menus.analyze, iconMap),
        log: this.format('log', menus.log, iconMap),
        toolkit: this.format('toolkit', menus.toolkit, iconMap),
        training: this.format('training', menus.training, iconMap),
        shoteyes: this.format('shoteyes', menus.shoteyes, iconMap),
        detective: this.format('detective', menus.detective, iconMap),
        shiftplan: this.format('shiftplan', menus.shiftplan, iconMap)
      };
    }

    return this.menus[app];
  }

  /**
   * 适配为 antd 所需的结构
   */
  private format(kind: string, items: Menu[], iconMap: MenuIconMap): MenuItems {
    if (items == null) {
      return [];
    }

    // 找到所有的一级菜单
    const parents = items.filter(item => item.kind === kind && item.parent === '');

    // 为每个一级菜单找到对应的子菜单
    return parents.map(parent => {
      // 找到所有的子菜单
      const children = items
        .filter(item => item.kind === kind && item.parent === parent.menu)
        .map(child => {
          if (child.menu as string === '-') {
            return { type: 'divider' };
          }
          return {
            icon: kind === 'System' ? undefined : iconMap[child.icon] ?? iconMap.default,
            key: child.menu,
            label: t(child.menu),
            title: t(child.menu),
            url: child.url
            // kind
          };
        });

      // 返回一级菜单
      return (parent.menu as string === '-')
        ? { type: 'divider' }
        : {
          icon: iconMap[parent.icon],
          key: parent.menu,
          label: t(parent.menu),
          title: t(parent.menu),
          url: parent.url,
          // kind,
          children
        };
    });
  }

}
